import { defineStore } from "pinia";
import axios from "axios";
import { moment } from "../utils";
import * as FormData from 'form-data'

export const useAppointmentStore = defineStore({
  id: "appointmentStore",

  state: () => ({
    loading: false,
    appointment: {
      glazing: null,
      other_service: null,
      windshield_damage: null,
      windshield_reparation: null,
      descaling_option: null,
      intervention_side: null,
      numberplate: null,
      brand_id: null,
      car_model_id: null,
      car_model_name: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      broken_glass_insurance: null,
      point_of_sale_id: null,
      appointment_date: null,
      appointment_time: null,
      request_type: null,
      additional_information: null,
      picture_of_window: null,
      picture_of_vehicle_registration_document: null,
      picture_of_insurance: null,
      failedQuery: false,
    },
    other_information: {
      brand_name: null,
      point_of_sale_name: null,
    },
    agencies: [],
    brands: [],
    car_models: [],
  }),
  actions: {
    compare(a, b) {
      if (a.URL_NOM_BU < b.URL_NOM_BU) {
        return -1;
      }
      if (a.URL_NOM_BU > b.URL_NOM_BU) {
        return 1;
      }
      return 0;
    },
    async fetchBrands() {
      if (this.brands.length == 0) {
        try {
          this.loading = true;
          const webServiceUrl = `/WS_Marque.php`;
          const params = new URLSearchParams();
          params.append("IDENTIFIANT", process.env.VUE_APP_WS_IDENTIFIER);
          params.append("CLE", process.env.VUE_APP_WS_KEY);
          const config = {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          };
          const res = await axios.post(
            `${process.env.VUE_APP_WS_ROOT}${webServiceUrl}`,
            params,
            config
          );
          this.brands = res.data.LISTE_MARQUE;
        } catch (e) {
          console.error(e);
        } finally {
          this.loading = false;
        }
      }
    },
    async fetchCarModels(brandId) {
      try {
        this.loading = true;
        const webServiceUrl = `/WS_Modele.php`;
        const params = new URLSearchParams();
        params.append("ID_MARQUE", brandId);
        params.append("IDENTIFIANT", process.env.VUE_APP_WS_IDENTIFIER);
        params.append("CLE", process.env.VUE_APP_WS_KEY);
        const config = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        };
        const res = await axios.post(
          `${process.env.VUE_APP_WS_ROOT}${webServiceUrl}`,
          params,
          config
        );
        this.car_models = res.data.LISTE_MODELE;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async fetchAgencies() {
      if (this.agencies.length == 0) {
        try {
          this.loading = true;
          const webServiceUrl = `/WS_BU.php`;
          const params = new URLSearchParams();
          params.append("IDENTIFIANT", process.env.VUE_APP_WS_IDENTIFIER);
          params.append("CLE", process.env.VUE_APP_WS_KEY);
          const config = {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          };
          const res = await axios.post(
            `${process.env.VUE_APP_WS_ROOT}${webServiceUrl}`,
            params,
            config
          );
          this.agencies = res.data.LISTE_BU;
        } catch (e) {
          console.error(e);
        } finally {
          this.loading = false;
        }
      }
      this.agencies.sort(this.compare);
    },
    async fetchCarModelFromLicencePlate(licencePlateNumber) {
      try {
        this.loading = true;
        const apiUrl = `/vehicle/details`;
        const config = {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_API_TOKEN}`,
            "Content-Type": "application/json",
          },
        };
        const data = {
          registration: licencePlateNumber,
        };
        const res = await axios.post(
          `${process.env.VUE_APP_API_ROOT}${apiUrl}`,
          data,
          config
        );
        return res.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async confirmAppointment() {
      this.appointment.appointment_date = this.appointment.appointment_date ? moment(
        this.appointment.appointment_date
      ).format("YYYY-MM-DD HH:mm:ss") : this.appointment.appointment_date;
      this.appointment.failedQuery = false
      try {
        this.loading = true;
        const apiUrl = `/meetings`;
        const config = {
          headers: { Authorization: `Bearer ${process.env.VUE_APP_API_TOKEN}` },
        };

        const formData = new FormData();

        if(this.appointment.picture_of_window) {
          formData.append('picture_of_window', this.appointment.picture_of_window)
        }

        if(this.appointment.picture_of_vehicle_registration_document) {
          formData.append('picture_of_vehicle_registration_document', this.appointment.picture_of_vehicle_registration_document)
        }

        if(this.appointment.picture_of_insurance) {
          formData.append('picture_of_insurance', this.appointment.picture_of_insurance)
        }

        for (const key in this.appointment) {
          if (
              (['picture_of_window', 'picture_of_vehicle_registration_document', 'picture_of_insurance'].indexOf(key) === -1)
              && this.appointment[key]
          ) {
            const value = typeof(this.appointment[key]) === "boolean" ? `${this.appointment[key]}` : this.appointment[key];
            formData.append(key, value);
          }
        }
        if (typeof(this.appointment.broken_glass_insurance) === "boolean") {
          formData.append('broken_glass_insurance', `${this.appointment.broken_glass_insurance}`)
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_ROOT}${apiUrl}`,
            formData,
          config
        );

        if (res.data && res.data.leadId) {
          return "" + res.data.leadId;
        }
        else {
          return "NotAvailable";
        }
      } catch (e) {
        this.appointment.failedQuery = true
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
});
